import React from 'react'

import { connect } from 'react-redux'

import {
  translate,
  defaultTheme,
  ViewTitle,
  SimpleShowLayout,
  SimpleForm,
  SelectInput,
} from 'admin-on-rest'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'

import Toggle from 'material-ui/Toggle'
import Checkbox from 'material-ui/Checkbox'
import TextField from 'material-ui/TextField'

import * as moment from 'moment'

import { updateAttendance, updateGrade } from '../reducers'
import { getStudentName, isStudentPresent } from '../helpers'

class InstructorCoursePageManageList extends React.Component {
  getGradeForStudent(grades, studentId) {
    // console.log('get grade', grades, studentId)
    return grades && grades.hasOwnProperty(studentId)
      ? grades[studentId]
      : undefined
  }

  render() {
    const { course, courseId, students } = this.props
    const grades = course.grades

    return (
      <div>
        <ViewTitle title="Cursanti" />
        <Table selectable={false}>
          <TableHeader
            enableSelectAll={false}
            adjustForCheckbox={false}
            displaySelectAll={false}
          >
            <TableRow>
              <TableHeaderColumn>Cursant</TableHeaderColumn>
              <TableHeaderColumn>
                Prezenta {moment(course.date).format('MMMM Do')}
              </TableHeaderColumn>
              <TableHeaderColumn>Nota</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {students.map(student => {
              return (
                <TableRow key={student.id}>
                  <TableRowColumn>{getStudentName(student)}</TableRowColumn>
                  <TableHeaderColumn>
                    <Checkbox
                      style={styles.checkbox}
                      disabled={
                        course.status === 'completed' && !this.props.isAdmin
                      }
                      checked={isStudentPresent(course, student.id)}
                      onCheck={(event, checked) => {
                        this.props.updateAttendance(
                          courseId,
                          student.id,
                          checked,
                        )
                      }}
                    />
                  </TableHeaderColumn>
                  <TableRowColumn>
                    <TextField
                      hintText="Adaugati nota"
                      value={this.getGradeForStudent(grades, student.id)}
                      disabled={
                        course.status === 'completed' ||
                        (!isStudentPresent(course, student.id) &&
                          !this.props.isAdmin)
                      }
                      onChange={(event, newValue) => {
                        this.props.updateGrade(courseId, student.id, newValue)
                      }}
                    />
                  </TableRowColumn>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </div>
    )
  }
}

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
}

export default connect(
  null,
  { updateAttendance, updateGrade },
)(InstructorCoursePageManageList)



// WEBPACK FOOTER //
// ./src/instructors/InstructorCoursePageManageList.js